//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import axios from '@nextcloud/axios';
import { generateUrl } from '@nextcloud/router';
import { showError } from '@nextcloud/dialogs';
import { DashboardWidget } from '@nextcloud/vue-dashboard';
import EmptyContent from '@nextcloud/vue/dist/Components/EmptyContent';
var requesttoken = axios.defaults.headers.requesttoken;
export default {
  name: 'Dashboard',
  components: {
    DashboardWidget: DashboardWidget,
    EmptyContent: EmptyContent
  },
  data: function data() {
    return {
      notifications: [],
      showMoreUrl: generateUrl('/apps/radio/#/favorites'),
      state: 'loading',
      darkThemeColor: OCA.Accessibility.theme === 'dark' ? 'ffffff' : '000000'
    };
  },
  computed: {
    items: function items() {
      return this.notifications.map(function (n) {
        return {
          id: n.id,
          targetUrl: generateUrl('/apps/radio/#/favorites'),
          avatarUrl: n.favicon,
          mainText: n.name,
          subText: n.tags.replaceAll(',', ', ')
        };
      });
    },
    emptyContentMessage: function emptyContentMessage() {
      if (this.state === 'error') {
        return t('radio', 'Error fetching favorite stations');
      } else if (this.state === 'ok') {
        return t('radio', 'No favorites added yet!');
      }

      return '';
    },
    emptyContentIcon: function emptyContentIcon() {
      if (this.state === 'error') {
        return 'icon-close';
      } else if (this.state === 'ok') {
        return 'icon-checkmark';
      }

      return 'icon-checkmark';
    }
  },
  beforeMount: function beforeMount() {
    this.fetchNotifications();
  },
  methods: {
    fetchNotifications: function fetchNotifications() {
      var _this = this;

      var req = {};
      axios.defaults.headers.requesttoken = requesttoken;
      axios.get(generateUrl('/apps/radio/api/favorites'), req).then(function (response) {
        _this.processNotifications(response.data);

        _this.state = 'ok';
      }).catch(function (error) {
        clearInterval(_this.loop);

        if (error.response && error.response.status === 401) {
          showError(t('radio', 'Failed to fetch favorite radio stations'));
          _this.state = 'error';
        } else {
          // there was an error in notif processing
          console.debug(error);
        }
      });
    },
    processNotifications: function processNotifications(newNotifications) {
      console.log(newNotifications);
      this.notifications = newNotifications;
    }
  }
};